<template>
    <div class="page-wrapper colours-fan-page">
        <div class="updated-message-wrapper" v-if="successUpdateMessage">
            <div class="updated-message" style="display: block;">
                <p><img src="/assets/img/checkbox-outline.svg" alt=""> {{ successUpdateMessage }}</p>
            </div>
        </div>
        <user-card v-if="$parent.documentData.name" :class="'mt-4'"></user-card>

        <div class="fan">
            <div class="canvas" v-bind:style="{ backgroundColor: defaultColor}">

                <router-link :to="{ name: 'Colour generator'}" class="close-icon">
                    <img src="/assets/colour-generator/images/close.svg">
                </router-link>

                <div class="dial"></div>


                <div class="color-display">

                    <div class="color-ring-outer">
                        <div class="color-ring" v-bind:style="setRingRotation()">
                            <div v-for="(c, index) in shades" v-bind:style="setRotation(index)">
                                <div class="color-brick"
                                     v-bind:style="{ backgroundColor: c}"
                                     @click="setDefault(c)"
                                     :class="{ ['current '+ textColourClass] : (c == defaultColor)}"
                                     >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="color-info" v-bind:class="textColourClass" v-bind:style="{ backgroundColor: defaultColor}">
                        <h2>{{ defaultColor }}</h2>
                        <div class="refresh" @click="setDefault()"><i class="ti-reload"></i></div>
                    </div>
                </div>
            </div>

            <div class="details">
                <div class="container">

                    <div class="row">
                        <div class="col-12">
                            <h2>Colours Fan</h2>
                            <p>Get a random Hex colour everytime your refresh the fan.</p>

                            <div class="row  justify-content-center">
                                <div class="col-12 col-md-8">
                                    <div class="colors-palette">

                                        <div class="colorbox" v-for="shade in uniqueShades">
                                            <div class="color" v-bind:style="{ backgroundColor: shade }"
                                                 v-if="shade"
                                                 @click="copyToClipboard(shade)"
                                                 v-bind:class="{ 'copied' : (copiedHex && copiedHex == shade) }"
                                                 v-bind:data-clipboard-text="shade">
                                                <span class="copy-text">Copy</span>
                                                <span class="check-image">
                                                    <img src="/assets/colour-generator/images/check.svg" class="check" alt="check">
                                                </span>
                                            </div>
                                            <div class="hex-code ng-binding text-uppercase">{{ shade }}</div>
                                        </div>

                                    </div>
                                    <p class="mt-3">Approx. colours amount: {{ sliderValue }}</p>
                                    <range-slider
                                        class="slider"
                                        min="6"
                                        max="17"
                                        step="1"
                                        v-model="sliderValue">
                                    </range-slider>
                                    <p>&nbsp;</p>
                                    <button @click="saveDocument()" v-if="!edit"
                                            class="btn btn-outline-primary mb-4">SAVE THIS THEME
                                    </button>

                                    <button @click="updateDocument()" v-if="edit && !readOnly"
                                            class="btn btn-outline-primary mb-4">{{ updateBtnText }}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import underscore from 'vue-underscore';
import ColorService from "../../services/colorService";
import RangeSlider  from 'vue-range-slider';
import UserCard from "../partials/UserCard";

export default {
    name: "ColourFan",
    components: {
        underscore,
        RangeSlider,
        UserCard
    },
    props: [
        'currentColour'
    ],
    data: function () {
        return {
            edit: false,
            readOnly: false,
            sliderValue: 9,
            defaultColor: '',
            shades: [],
            uniqueShades: [],
            color: null,
            deg: null,
            textColourClass: null,
            rotateFactor: null,
            ringDeg: null,
            copiedHex: null,
            document: {},

            updateBtnText: 'UPDATE',
            successUpdateMessage: '',
        }
    },
    mounted() {

        if (this.$route.query.id) {
            this.loadDocument();

            this.edit = true;
        } else {
            // if there is local storage
            let localData = localStorage.getItem('temp_app_data')
            if(localData) {
                localData = JSON.parse(localData);
                this.defaultColor = localData.entity_data.colour;
                this.sliderValue = localData.entity_data.coloursAmount;

                localStorage.removeItem('temp_app_data');
            // default colour
            } else if(!this.defaultColor) {
                this.defaultColor = '#ee3f50';
                // check for valid hex code on page reload
                let hash = window.location.hash;
                if(/^#[0-9A-F]{6}$/i.test(hash)) {
                    this.defaultColor = hash; //override if present
                } else {
                    window.location.hash = this.defaultColor.replace('#', '');
                }

            }



            this.init();
        }




        // clone
        if(this.$route.query.clone && this.document) {
            this.clone();
        }

    },
    watch: {
        sliderValue: function(newVal, oldVal) {
            if(newVal != oldVal) {
                this.init(this.defaultColor);
            }
        }
    },
    methods: {

        loadDocument() {
            this.$parent.loadDoc(this.$route.query.id).then(({data}) => {
                this.document = data.doc;

                let meta;
                if(typeof data.entity.meta == 'object') {
                    meta = data.entity.meta;
                } else {
                    meta = JSON.parse(data.entity.meta);
                }

                this.defaultColor = meta.colour;
                this.sliderValue = meta.coloursAmount;

                this.init();

                this.readOnly = !this.$parent.checkIfIamAuthor();
            });

        },
        saveDocument() {
            this.$parent.documentData.entity_data = {
                colour: this.defaultColor,
                colours: this.shades,
                coloursAmount: this.sliderValue,
            };
            this.$parent.saveDoc();
        },

        updateDocument() {
            this.updateBtnText = 'UPDATING...';
            this.$parent.documentData.entity_data = {
                colour: this.defaultColor,
                colours: this.shades,
                coloursAmount: this.sliderValue,
            };
            this.$parent.updateDoc(this.$route.query.id);
            setTimeout(() => {
                this.updateBtnText = 'UPDATE';

                this.successUpdateMessage = 'Document saved!';
                setTimeout(() => {
                    this.successUpdateMessage = '';
                }, 2000);

            }, 1000)
        },


        // Initialisation when page is loaded
        init() {
            let stepper = (this.sliderValue+1)/2;
            let colorSteps = Math.floor(50/stepper);
            // set colour service
            this.color = new ColorService();

            // set default colour
            // this.defaultColor = colourHex;
            if(!this.defaultColor) {
                this.defaultColor = this.color.randomHex();
                window.location.hash = this.defaultColor.replace('#', '');
            }

            // colour of the text inside the fan
            this.textColourClass = this.setClass(this.defaultColor, true);

            // generate shades
            this.setShades(colorSteps);

            this.uniqueShades = _.uniq(this.shades);
            let deg = (360/(this.shades.length-1));
            let hex = this.defaultColor;
            let rotateFactor = _.findIndex(this.shades, function(item){
                return item === hex;
            });

            // outer ring updates
            this.ringDeg = deg*(rotateFactor+1);






            /**
             * Debug code
             *
             * @fixme remove this
             */
            let debug = false;
            if(debug) {
                // console.log('init method called');
                let shadesArray = this.color.getShades(this.defaultColor, 6);

                shadesArray.forEach(function(c) {
                    console.log(c, this.color.toRGB(c));
                }, this);
            }
        },

        clone() {
            this.$parent.settingCloneTitle = true;
            // console.log(this.$parent.documentData);
            // console.log('cloning...')
        },

        // On click action to change the default colour
        setDefault(colourHex)  {
            if(colourHex) {
                this.defaultColor = colourHex;
            } else {
                this.defaultColor = '';
            }

            this.init();
            this.copiedHex = null;
            if(typeof colourHex != 'undefined') {
                window.location.hash = colourHex.replace('#', '');
            }
        },

        // setting the shades for main colour
        setShades: function (colorSteps) {
            this.shades = this.color.getShades(this.defaultColor, colorSteps);
        },

        // whole fan rotation
        setRingRotation: function() {
            return {
                transform: 'rotate(-'+this.ringDeg+'deg) translateZ(0)'
            };
        },

        // set the rotation of each wing
        setRotation: function (index) {
            var deg = (360/(this.shades.length-1));
            var size = Math.floor((100/(this.shades.length-2) + Math.PI)/2);

            var i = index+1;
            var d = deg*(i);
            var m = '0 -'+size+'em';
            var z = this.shades.length - i;
            var t = (i * 0.08);
            var r = '';
            var s = '';
            var f = '';

            // hackery
            if(i === this.shades.length) {
                d = 360; //$scope.deg;
                m = '0 -'+size+'em 0 0';
                z = this.shades.length;
            }

            r = 'rotate('+d+'deg)';

            return {
                transform: r + s,
                fontSize: f,
                margin: m,
                transitionDelay: t+'s',
                zIndex: z
            };
        },

        // to set colour of text in the fan
        setClass: function (colourHex, affectText) {
            if(colourHex) {
                let classes = [];
                if(affectText) {
                    let text = this.color.brightness(colourHex) < 155 ? 'fg-light' : 'fg-dark';
                    classes.push(text);
                }
                return classes.join(' ');
            }
        },

        // Copy to clipboard
        copyToClipboard: function (colourHex) {
            this.$copyText(colourHex).then((e) => {
                this.copiedHex = colourHex;

                // reset to normal after 2 seconds
                setTimeout(() => {
                    this.copiedHex = null;
                }, 2000)
            })
        }
    },
}
</script>

<style scoped>
    .slider {
        /* overwrite slider styles */
        width: 200px;
    }
    .colours-fan-page .details {
        margin-bottom: 0px;
    }
</style>
